<template>

    <div class="loader row">
        <div class="col-sm-2 col-sm-offset-5">
            <div class="box box-solid">
                <div class="box-body" style="min-height:100px"></div>
                <div class="overlay">
                    <i class="fa fa-refresh fa-spin"></i>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    name:'Loader',
}

</script>
